import { useContext } from "react";
import { participantContext } from "./participant.context";

export const useParticipants = () => {
  const context = useContext(participantContext);
  return context;
};
